import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CodeSCACListItem extends SearchModelBase {
    id: number = 0;
    carrierName: string = '';
    code: string = '';
    sName: string = '';
    senderId: string = '';
    receiverId: string = '';
    customerCode: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Carrier', width: 600, dataIndex: 'carrierName'}),
        XCol.Create({ col: 1, text: 'Code', width: 80, dataIndex: 'code'}),
        XCol.Create({ col: 2, text: 'Company', width: 300, dataIndex: 'sName'}),
        XCol.Create({ col: 3, text: 'Sender ID', width: 150, dataIndex: 'senderId'}),
        XCol.Create({ col: 4, text: 'Receiver ID', width: 150, dataIndex: 'receiverId'}),
        XCol.Create({ col: 5, text: 'Customer Code', width: 150, dataIndex: 'customerCode'})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: CodeSCACListItem.prototype.carrierName, orderByAscending: true };

    public static formatData(data: CodeSCACListItem[]) {
        return data.map((d: CodeSCACListItem) => ({
          ...d,
        }));
    }

}
